module.exports = __webpack_public_path__ + "img/nine_thirty_five.15e11d64.svg";